// extracted by mini-css-extract-plugin
export default {"searchWrapper":"SourcesPage_searchWrapper__mZYv6","searchInput":"SourcesPage_searchInput__jPskw","actorsHeader":"SourcesPage_actorsHeader__1UtWY"};